import { ComponentProps } from 'react';
import Modal from 'antd/es/modal';
import clsx from 'clsx';

interface OpModalProps extends ComponentProps<typeof Modal> {
  testId?: string;
}

/**
 * OpModal is a wrapper around Ant Design's Modal component.
 * It provides a dialog overlay for displaying content that requires user interaction or attention.
 * 
 * Use this component for confirmations, forms, detailed information, or any content that should
 * temporarily take focus from the main application. Defaults to centered positioning and destroys
 * content on close for better performance.
 * 
 * @example
 * <OpModal
 *   open={isOpen}
 *   onCancel={handleClose}
 *   title="Confirm Action"
 *   onOk={handleConfirm}
 * >
 *   Are you sure you want to proceed?
 * </OpModal>
 * 
 */
export const OpModal = ({
  children,
  className,
  centered = true,
  destroyOnHidden = true,
  testId,
  ...modalProps
}: OpModalProps) => (
  <Modal
    className={clsx('op-modal', className)}
    centered={centered}
    data-testid={testId}
    destroyOnHidden={destroyOnHidden}
    {...modalProps}
  >
    {children}
  </Modal>
);
